import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { loadJivoChat, destroyJivoChat } from "@/utils/jivoChat";

/**
 * Component that conditionally loads JivoChat widget.
 * JivoChat is only shown when:
 * 1. User is authenticated (either regular auth or brand auth)
 * 2. Current route is a brand route (but NOT on auth pages)
 */
export function JivoChatLoader() {
  const { isAuthenticated, brandAuth } = useAuth();
  const location = useLocation();

  // Check if it's a brand route but exclude auth, pricing, and preview routes
  const isBrandRoute = location.pathname.startsWith("/brand/") && 
                       !location.pathname.startsWith("/brand/auth") &&
                       !location.pathname.startsWith("/brand/pricing") &&
                       !location.pathname.includes("preview");

  // Only show JivoChat on authenticated brand routes
  const shouldShowJivoChat = isBrandRoute && (isAuthenticated || brandAuth.isAuthenticated);

  useEffect(() => {
    if (shouldShowJivoChat) {
      loadJivoChat();
    } else {
      destroyJivoChat();
    }

    // Cleanup on unmount
    return () => {
      destroyJivoChat();
    };
  }, [
    shouldShowJivoChat,
    location.pathname,
    isAuthenticated,
    brandAuth.isAuthenticated,
  ]);

  return null;
}
